import createLucideIcon from '../createLucideIcon';
import type { LucideIconNode, LucideIconData } from '../types';

export const __iconData: LucideIconData = {
  name: 'circle-letter-p-off',
  size: 24,
  node: [
    ['path', { d: 'M12 12h1a2 2 0 000-4H9.5a.5.5 0 00-.5.5V9', key: '1smka7' }],
    ['path', { d: 'M15.652 21.31A10 10 0 012.691 8.348', key: '1wedyz' }],
    ['path', { d: 'M22 22 2 2', key: '1r8tn9' }],
    ['path', { d: 'M4.929 4.929a10 10 0 0116.729 4.483 10 10 0 01-2.588 9.658', key: '1qahep' }],
    ['path', { d: 'M9 14.657V16', key: '16yar1' }],
  ],
  aliases: ['parking-circle-off', 'circle-parking-off'],
};

/**
 * @deprecated Access `__iconData` instead.
 */
export const __iconNode: LucideIconNode[] = __iconData.node;

/**
 * @component @name CircleLetterPOff
 * @description Lucide SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTIgMTJoMWEyIDIgMCAwMDAtNEg5LjVhLjUuNSAwIDAwLS41LjVWOSIgLz4KICA8cGF0aCBkPSJNMTUuNjUyIDIxLjMxQTEwIDEwIDAgMDEyLjY5MSA4LjM0OCIgLz4KICA8cGF0aCBkPSJNMjIgMjIgMiAyIiAvPgogIDxwYXRoIGQ9Ik00LjkyOSA0LjkyOWExMCAxMCAwIDAxMTYuNzI5IDQuNDgzIDEwIDEwIDAgMDEtMi41ODggOS42NTgiIC8+CiAgPHBhdGggZD0iTTkgMTQuNjU3VjE2IiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/circle-letter-p-off
 * @see https://lucide.dev/guide/packages/lucide-react - Documentation
 *
 * @param {Object} props - Lucide icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const CircleLetterPOff = createLucideIcon(__iconData);

export default CircleLetterPOff;
